import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestReducer(state = initialState.budgetrequest, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETREQUEST_SUCCESS:
      return action.budgetrequest;
    default:
      return state;
  }
}
